<template>
  <div style="overflow: hidden">
    <!-- 头部登录 -->
    <HeaderTop ref="shopcar"></HeaderTop>
    <Slider></Slider>
    <!-- 头部搜索和tabs -->
    <div class="center">
      <div class="supperHead">
        <div style="padding-top: 50px;padding-bottom: 10px;border-bottom: 2px solid rgb(95, 150, 244)">
          <a href="/">
            <img
              class="imgs"
              src="@/assets/images/home/logo1.png"
              alt=""
              width="148px"
            />
          </a>
          <span style="margin-left: 50px;font-size: 20px;font-weight: 700">自营活动</span>
        </div>
      </div>
      <div style="margin-top: 5px">
        <div>
          <Input v-model="activityName" placeholder="请输入活动名称" style="width: 300px;margin-right: 10px" />
          <Input v-model="partName" placeholder="请输入配件编码/配件名称" style="width: 300px;margin-right: 10px" />
          <Select v-model="storeName" style="width:200px;margin-right: 10px">
            <Option v-for="(item,ind) in storeList" :value="item.leagueId" :key="ind">{{ item.leagueName }}</Option>
          </Select>
          <Button style="margin-left: 30px" @click="reset">重置</Button>
          <Button type="primary" style="margin-left: 10px" @click="getList">查询</Button>
        </div>
        <Tabs @on-click="relevanceclick" v-model="tabPage" >
          <TabPane label="单品促销" name="2" >
            <div class="goodsList">
              <div class="goods" v-for="(item, ind) in goodsList" :key="ind" @click="goDetails(item)">
                <div style="height: 130px">
                  <div class="title">{{item.activityName}}</div>
                  <Row>
                    <Col span="7" style=" display: flex;flex-direction: column;justify-content: center;">
                      <img
                        v-if="item.pictureUrl"
                        :src="item.pictureUrl"
                        alt="图片缺失"
                        width="100%"
                      />
                      <img
                        v-else
                        src="@/assets/images/shoppingCart/2.png"
                        alt="图片缺失"
                        width="100%"
                      />
                    </Col>
                    <Col span="14" style="padding-left: 10px">
                      <div>
                        <span class="brand">{{item.qualityTypeName}}</span>
                        <span class="code" :title="item.oeCode">{{item.oeCode}}</span>
                      </div>
                      <div>{{item.carBrandName}}</div>
                      <div class="title" :title="item.fullName">{{item.fullName}}</div>
                      <div class="oe-p" @mouseleave="closeRelevance(ind)">
                        <p
                          @mouseenter="getRelevance(item.id, ind, item)"
                          v-if="item.oeCodeList.length"
                        >
                          OE号：{{ item.oeCodeList[0]
                          }}<i
                            class="ivu-icon ivu-icon-ios-arrow-down"
                            v-if="item.oeCodeList.length > 1"
                          ></i>
                        </p>
                        <div
                          class="relevance"
                          :tabIndex="1"
                          v-if="item.oeCodeList.length > 1"
                        >
                          <div
                            class="relevanceBox"
                            :class="item.isShow ? 'show' : ''"
                          >
                            <p v-for="i in item.oeCodeList.slice(1)" :key="i">
                              {{ i }}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div>
                        <span
                          style="margin-right: 15px;"
                          >服务:</span
                        >
                        <span v-show="item.genuineGuarantee" style="margin-right: 10px"
                          ><i style="color:#70b603;font-size:16px" class="iconfont icon-a-lujing153"></i></span
                        >
                        <span v-show="item.technicalSupport" style="margin-right: 10px"
                          ><i style="color:#f59a23;font-size:16px" class="iconfont icon-a-ziyuan4"></i></span
                        >
                        <span v-show="item.warrantyService" style="margin-right: 10px"
                          ><i style="color:#d9001b;font-size:16px" class="iconfont icon-a-ziyuan5"></i></span
                        >
                        <span v-show="item.returnPromise" style="margin-right: 10px"
                          ><i style="color:#02a7f0;font-size:16px" class="iconfont icon-a-ziyuan21"></i></span
                        >
                      </div>  
                    </Col>
                    <Col span="3">
                      <div style="text-decoration:line-through; margin-top: 20px">￥{{item.price}}</div>
                      <div style="color: red; font-weight: 700">￥{{item.activityPrice}}</div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </TabPane>
          <TabPane label="组合促销" name="3">
            <div class="goodsList">
              <div class="goods2" v-for="(item, ind) in goodsList" :key="ind" @click="goDetails(item)">
                <div>
                  <div class="title">
                    <img width="24px" src="@/assets/images/sale.png" alt="" style="vertical-align: bottom">
                    {{item.activityName}}
                  </div>
                  <div style="padding: 10px 0">
                    <span class="detail">{{item.totalCount}}个商品</span>
                    <span class="detail">组合价</span>
                    <span class="detail red" style="font-weight: 700">￥{{item.totalPrice}}</span>
                  </div>
                  <div>
                    <span class="detail">活动剩余</span>
                    <span class="red">{{item.timeHorizon}}</span>
                  </div>
                </div>
              </div>
            </div>
          </TabPane>
          <TabPane label="买赠" name="1">
            <div class="goodsList">
              <div class="goods" style="background-color: #f3fbfe" v-for="(item, ind) in goodsList" :key="ind" @click="goDetails(item)">
                <div style="height: 130px">
                  <div class="title">{{item.activityName}}</div>
                  <Row>
                    <Col span="7" style=" display: flex;flex-direction: column;justify-content: center;">
                      <img
                        v-if="item.pictureUrl"
                        :src="item.pictureUrl"
                        alt="图片缺失"
                        width="100%"
                      />
                      <img
                        v-else
                        src="@/assets/images/shoppingCart/2.png"
                        alt="图片缺失"
                        width="100%"
                      />
                    </Col>
                    <Col span="14" style="padding-left: 10px">
                      <div>
                        <span class="brand">{{item.qualityTypeName}}</span>
                        <span class="code" :title="item.oeCode">{{item.oeCode}}</span>
                      </div>
                      <div>{{item.carBrandName}}</div>
                      <div class="title" :title="item.fullName">{{item.fullName}}</div>
                      <div class="oe-p" @mouseleave="closeRelevance(ind)">
                        <p
                          @mouseenter="getRelevance(item.id, ind, item)"
                          v-if="item.oeCodeList.length"
                        >
                          OE号：{{ item.oeCodeList[0]
                          }}<i
                            class="ivu-icon ivu-icon-ios-arrow-down"
                            v-if="item.oeCodeList.length > 1"
                          ></i>
                        </p>
                        <div
                          class="relevance"
                          :tabIndex="1"
                          v-if="item.oeCodeList.length > 1"
                        >
                          <div
                            class="relevanceBox"
                            :class="item.isShow ? 'show' : ''"
                          >
                            <p v-for="i in item.oeCodeList.slice(1)" :key="i">
                              {{ i }}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div>
                        <span
                          style="margin-right: 15px;"
                          >服务:</span
                        >
                        <span v-show="item.genuineGuarantee" style="margin-right: 10px"
                          ><i style="color:#70b603;font-size:16px" class="iconfont icon-a-lujing153"></i></span
                        >
                        <span v-show="item.technicalSupport" style="margin-right: 10px"
                          ><i style="color:#f59a23;font-size:16px" class="iconfont icon-a-ziyuan4"></i></span
                        >
                        <span v-show="item.warrantyService" style="margin-right: 10px"
                          ><i style="color:#d9001b;font-size:16px" class="iconfont icon-a-ziyuan5"></i></span
                        >
                        <span v-show="item.returnPromise" style="margin-right: 10px"
                          ><i style="color:#02a7f0;font-size:16px" class="iconfont icon-a-ziyuan21"></i></span
                        >
                      </div> 
                    </Col>
                    <Col span="3">
                      <div style="text-decoration:line-through; margin-top: 20px">￥{{item.price}}</div>
                      <div style="color: red; font-weight: 700">￥{{item.activityPrice}}</div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </TabPane>
        </Tabs>
        <div style="float: right; margin-top: 20px">
          <Page :total="total" show-total @on-change="detailPageChange" :page-size="page.size" size="small">
            <span>共{{ total }}个活动</span>
          </Page>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderTop from '@/views/base/common/header-top.vue'
import Slider from '@/views/base/common/slider.vue'
import { getStoreList, getGoodsList } from '@/api/activity/index.js'
export default {
  name: 'activity',
  components: {
    HeaderTop,
    Slider
  },
  data() {
    return {
      tabPage: '2',
      activityName: '',
      partName: '',
      storeName: '',
      storeList: [],
      goodsList: [],
      page: {
        current: 1,
        size: 12
      },
      total: 0
    }
  },
  created() {
    this.getStore()
  },
  methods: {
    // oe展开
    getRelevance(id, index, item) {
      this.$set(this.goodsList[index], 'isShow', true)
    },
    // 关闭oe
    closeRelevance(index) {
      this.$set(this.goodsList[index], 'isShow', false)
    },
    relevanceclick() {
      console.log(this.tabPage);
      if(this.tabPage === '3'){
        this.page.size = 20
      }else{
        this.page.size = 12
      }
      this.getList()
    },
    async getList() {
      let data = {
        activityName: this.activityName,
        tenantId: this.storeName,
        part: this.partName,
        activityType: this.tabPage
      }
      let res = await getGoodsList(data,this.page)
      console.log(res,'=-----');
      if(res.status) {
        this.goodsList = res.data.records
        this.total = res.data.total
      }
    },
    async getStore() {
      let res = await getStoreList()
      if(res.status && res.data.length > 0){
        this.storeList = res.data
        this.storeName = res.data[0].leagueId
      }else{
        this.storeList = []
        this.storeName = ""
      }
      this.getList()
    },
    goDetails(item) {
      console.log(item)
      console.log(this.tabPage);
      // this.$router.push({
      //   path: '/Partsdetails',
      //   query: {
      //     // partId: item.partsId
      //     partId: '1574602251444154368'
      //   }
      // })
      if(this.tabPage === '3') {
        this.$router.push({
          path: '/PartsdetailsGroup',
          query: {
            // partId: item.partsId
            partId: item.activityId
          }
        })
      }else {
        this.$router.push({
          path: '/Partsdetails',
          query: {
            partId: item.partsId
          }
        })
      }
    },
    reset() {
      this.activityName = ''
      this.partName = ''
      this.storeName = this.storeList[0].leagueId
    },
    // 分页
    detailPageChange(val) {
      this.page.current = val
      this.getList()
    }
  }
}
</script>
<style lang="less" scoped>
  .center {
    width: 1200px;
    margin: 0 auto;
    margin-top: 50px;
    .supperHead {
      margin-top: 40px
    }
    .goodsList{
      
      .goods{
        width: 30%;
        margin-right: 20px;
        margin-top: 20px; 
        float: left;
        // display: flex;
        // align-items: center;
        // justify-content: center;
        background-color: #fefaf4;
        padding: 10px;
        cursor: pointer
      }
      .goods:nth-child(3){
        margin-right: 0;
      }
      .goods2{
        width: 22%;
        margin-right: 20px;
        margin-top: 20px; 
        float: left;
        padding: 10px;
        // display: flex;
        // align-items: center;
        // justify-content: center;
        background-color: #fdf3f4;
        cursor: pointer
      }
      .goods2:nth-child(4){
        margin-right: 0;
      }
    }
  }
  .brand{
    width: 70px;
    display: inline-block;
    text-align: center;
    background-color: #f59a23;
    border-radius: 5px;
    color: #fff
  }
  .code{
    padding-left: 10px;
    font-weight: 700
  }
  .detail {
    display: inline-block;
    width: 30%;
  }
  .red {
    color: #d9001b;
  }
  .title{
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .code{
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 110px;
    vertical-align: top
  }
  /deep/.ivu-tabs-bar{
    border: none;
  }
  .oe-p {
    font-size: 14px;
    // padding-top: 19px;
    // padding-left: 4px;
    // color: #505050;
    position: relative;
    p {
      text-align: left;
      font-size: 14px;
      // color: #505050;
      // cursor: pointer;
    }
    p:hover .ivu-icon-ios-arrow-down {
      transform: rotate(-180deg);
    }
    .ivu-icon-ios-arrow-down {
      font-size: 14px;
      cursor: pointer;
      transition: all 0.5s ease 0s;
    }
    .ivu-icon-ios-arrow-down:hover {
      transform: rotate(-180deg);
    }
    // .relevance {
    // cursor: pointer;
    // position: relative;
    // width: 20px;
    // margin: 0 5px;
    // img {
    //   width: 18px;
    //   height: 18px;
    // }
    // .icon-xiaodengpao {
    //   color: #b9b9b9;
    // }
    span {
      cursor: pointer;
    }
    .relevanceBox {
      // display: flex;
      padding: 2px 15px 2px 2px;
      position: absolute;
      top: 17px;
      left: 45px;
      // width: 100px;
      height: auto;
      border: 1px solid #e2e2e2;
      background-color: #fff;
      display: none;
      z-index: 99;
      overflow-y: auto;
      word-wrap: break-word;
      span {
        font-size: 12px;
        line-height: 18px;
        font-weight: normal;
        // display: inline-block;
        padding-bottom: 6px;
      }
    }
    .show {
      display: block;
    }
    // }
  }
</style>